import React from "react";
import { useParams } from "react-router-dom";
import { CategoryOfferingCard } from "./category_offering_card";
import { useMediaQuery } from "@/hooks/use_media_query";
import { CatalogOffering } from "@/data/catalog";
import { useI18n } from "@/lib/i18n/i18n_provider";
import { Spacer } from "@/offering/spacer";
import { Divider } from "../../../components";

interface OfferingsProps {
  items: CatalogOffering[];
  membership?: boolean;
  title?: string;
}

interface OfferingParams {
  categorySlug: string;
}

export function Offerings(props: OfferingsProps) {
  const { items, membership = true, title } = props;
  const { categorySlug } = useParams<OfferingParams>();
  const { fbt } = useI18n();
  const mq = useMediaQuery();

  return (
    <div data-testid="offerings">
      <h3
        dangerouslySetInnerHTML={{
          __html:
            title || fbt(`${membership ? "Membership" : "On demand"} options`),
        }}
      />
      <Spacer size={24} />
      <div className="d-flex flex-wrap gap-4">
        {items.map(
          ({
            image,
            title,
            description,
            slug,
            comingSoon,
            membership,
            id,
            longDescription,
            ctaLabel,
          }) => (
            <div
              key={id}
              data-testid="category-offerings-item"
              style={{
                width:
                  mq.device !== "desktop"
                    ? "100%"
                    : items.length >= 3
                    ? "calc(100% / 3 - 16px)"
                    : "calc(50% - 16px)",
              }}
            >
              <CategoryOfferingCard
                key={id}
                image={image}
                title={title}
                description={description}
                offeringSlug={slug}
                comingSoon={comingSoon}
                membership={membership}
                fromCategory={categorySlug}
                longDescription={longDescription}
                ctaLabel={ctaLabel}
              />
            </div>
          )
        )}
      </div>
      <Divider />
    </div>
  );
}
